import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem('token');
  const userInfoString = localStorage.getItem('userInfo') || localStorage.getItem('user');
  const location = useLocation();

  if (!token || token === 'null' || token === 'undefined' || !userInfoString || userInfoString === 'null' || userInfoString === 'undefined') {
    // Not logged in, redirect to login page
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  let userInfo;
  try {
    userInfo = JSON.parse(userInfoString);
  } catch (error) {
    // Invalid JSON, force login
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const userRole = userInfo.role || 'resident';

  // Check if role is authorized
  if (allowedRoles && !allowedRoles.includes(userRole)) {
    // Role not authorized, redirect to their respective dashboard
    if (userRole === 'admin') {
      return <Navigate to="/admin" replace />;
    } else if (userRole === 'security') {
      return <Navigate to="/security" replace />;
    } else {
      return <Navigate to="/resident" replace />;
    }
  }

  // Authorized, return children
  return children;
};

export default ProtectedRoute;
